/*
  assets/photo-frame-modal.js

  Rendert de fotolijst-configurator (aantal frames + maten) binnen de add-on modal
  van de systeem-configurator. Bepaalt per frame de tier (Small/Medium/Large) op
  basis van de grootste zijde, en levert kant-en-klare cart line items op.

  Laden VOOR je configurator-js, bijv. in theme.liquid of in de configurator-sectie:
    {{ 'photo-frame-modal.js' | asset_url | script_tag }}

  Instellingen komen (optioneel) uit een JSON-script met id "photo-frame-settings".
  Zonder dat script worden de DEFAULTS hieronder gebruikt.
*/

window.PhotoFrameModal = (function () {
  'use strict';

  var DEFAULTS = {
    handles: ['modular-photo-frame-collage'], // handles van producten die de frame-configurator krijgen
    sizeOptionName: 'Size',                   // optie die wordt afgeleid uit de maten
    min: 40,
    smallMax: 70,
    mediumMax: 120,
    largeMax: 180,
    prices: { Small: 2.50, Medium: 3.50, Large: 6.00 },

    /* ── Ruimte in het systeem (mm) die één frame per tier inneemt ──
       Wordt niet meer gebruikt voor de ruimteberekening (zie RUIMTE-SCHATTING
       hieronder), maar blijft staan voor eventueel later gebruik. */
    tierLengths: { Small: 0, Medium: 0, Large: 0 },

    /* ── Maximaal aantal frames per tier (alleen in de modal) ──
       null = geen limiet voor die tier. */
    tierLimits: { Small: 3, Medium: 2, Large: 1 },

    /* Maximaal aantal frames in totaal. null = som van de tierLimits (hier 6). */
    totalLimit: null,

    /* ── Welke kant van de collage tegen de systeemlengte aan wordt gehouden ──
       'auto'   = huidig gedrag: volgt de oriëntatie-sectie waar de add-on in
                  staat (horizontal → breedte, vertical → hoogte). Werkt alleen
                  goed als die sectie er ook daadwerkelijk is.
       'width'  = altijd de breedte gebruiken, ongeacht oriëntatie-sectie.
       'height' = altijd de hoogte gebruiken, ongeacht oriëntatie-sectie.
       Zet dit per product/sectie via het "photo-frame-settings" script-tag,
       bijv. { "lengthDimension": "height" } — handig voor een configuratie
       die geen (of de verkeerde) oriëntatie-toggle heeft. */
    lengthDimension: 'auto',

    maxFrames: 10,
    currency: 'EUR'
  };

  var settings = (function () {
    var s = {}, k;
    for (k in DEFAULTS) s[k] = DEFAULTS[k];
    var el = document.getElementById('photo-frame-settings');
    if (el) {
      try {
        var json = JSON.parse(el.textContent.trim() || '{}');
        for (k in json) {
          if (json[k] !== undefined && json[k] !== null && json[k] !== '') s[k] = json[k];
        }
      } catch (e) {}
    }
    return s;
  })();

  // ── DEBUG: regeltje in de modal dat live de geschatte breedte/hoogte
  //    toont tijdens het invullen van de maten. Staat standaard UIT. Zet
  //    DEBUG_FRAME_ESTIMATE hieronder op true om 'm weer aan te zetten (en
  //    terug op false om 'm weer te verbergen) — verder hoef je niets aan
  //    te passen. ──
  var DEBUG_FRAME_ESTIMATE = false;

  /* ── Helpers ─────────────────────────────────────────────── */

  function isFrameProduct(product) {
    return !!(product && settings.handles.indexOf(product.handle) !== -1);
  }

  // Vertaalt de meegegeven oriëntatie (uit de oriëntatie-sectie) naar de
  // daadwerkelijk te gebruiken richting. Volgorde van voorrang:
  //   1. overrideDimension — per add-on ("data-length-dimension" op de
  //      "View"-knop, afkomstig van het addon.length_dimension metaobject-veld)
  //   2. settings.lengthDimension — pagina-brede fallback via het
  //      "photo-frame-settings" script-tag
  //   3. orientation — huidig gedrag (volgt de oriëntatie-sectie)
  // 'auto' (of leeg) op beide niveaus betekent: val door naar het volgende.
  function resolveLengthOrientation(orientation, overrideDimension) {
    if (overrideDimension === 'height') return 'vertical';
    if (overrideDimension === 'width') return 'horizontal';
    if (settings.lengthDimension === 'height') return 'vertical';
    if (settings.lengthDimension === 'width') return 'horizontal';
    return orientation; // 'auto' op beide niveaus: huidige gedrag
  }

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: settings.currency }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + settings.currency;
    }
  }

  // Valideert hoogte OF breedte afzonderlijk (zelfde logica als de productpagina)
  function validateSingle(val) {
    if (!isFinite(val) || val <= 0) return { valid: false, error: 'empty' };
    if (val < settings.min)         return { valid: false, error: 'Min = ' + settings.min + 'mm' };
    if (val > settings.largeMax)    return { valid: false, error: 'Max = ' + settings.largeMax + 'mm' };
    return { valid: true, error: null };
  }

  function classifyTier(h, w) {
    var largest = Math.max(h, w);
    if (largest <= settings.smallMax)  return { tier: 'Small',  price: Number(settings.prices.Small) };
    if (largest <= settings.mediumMax) return { tier: 'Medium', price: Number(settings.prices.Medium) };
    return                                    { tier: 'Large',  price: Number(settings.prices.Large) };
  }

  // Limiet voor één tier, of null als er geen limiet is
  function tierLimit(tier) {
    var limits = settings.tierLimits || {};
    var val = limits[tier];
    if (val === null || val === undefined || val === '') return null;
    return Number(val);
  }

  // Maximaal aantal frames in totaal
  function totalLimit() {
    if (settings.totalLimit) return Number(settings.totalLimit);
    var sum = 0;
    ['Small', 'Medium', 'Large'].forEach(function (t) {
      var l = tierLimit(t);
      if (l !== null) sum += l;
    });
    return sum > 0 ? sum : (parseInt(settings.maxFrames, 10) || 10);
  }

  // Foutmelding, bijv. "Maximum of 1x Large, 2x Medium and 3x Small — Adjust ..."
  function limitsText() {
    var parts = [];
    ['Large', 'Medium', 'Small'].forEach(function (t) {
      var l = tierLimit(t);
      if (l !== null) parts.push(l + 'x ' + t);
    });
    if (!parts.length) return 'Please fill in all boxes';
    var list = parts.length > 1
      ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1]
      : parts[0];
    return 'Maximum of ' + list + ' \u2014 Adjust the sizes or reduce the number of frames.';
  }

  /* ── RUIMTE-SCHATTING (oppervlakte-methode) ─────────────────
     Schat de totale breedte (mm) die een set fotolijstjes samen inneemt
     wanneer ze in een collage worden opgehangen (dus niet allemaal naast
     elkaar, maar verdeeld over een paar rijen zoals in de praktijk).

     Werkwijze:
       1. Tel de oppervlakte (h × w) van alle lijstjes bij elkaar op.
       2. Ga uit van een collage die iets breder dan hoog is (RATIO) en
          bereken daaruit een "kale" schatting van de breedte.
       3. Vermenigvuldig met een veiligheidsfactor (SAFETY_FACTOR) voor
          extra marge — hoger dan 1 betekent een ruimere (grotere) schatting.
       4. Klem het resultaat tussen twee harde grenzen:
          - nooit smaller dan het breedste losse lijstje
          - nooit breder dan de som van alle breedtes (alles op 1 rij)
          Bij 1 lijstje vallen beide grenzen samen, dus dan komt er altijd
          precies de juiste (exacte) breedte uit. */
  var FRAME_AREA_RATIO = 1.3;          // aangenomen lange-zijde : korte-zijde-verhouding van de collage
  var FRAME_AREA_SAFETY_FACTOR = 1.4;  // >1 = extra marge; hoger = grotere schatting
  var SINGLE_FRAME_MARGIN = 20;        // extra mm speling wanneer er precies 1 lijstje is (zie hieronder)

  /*
    orientation: 'horizontal' → schat de BREEDTE (voor een horizontaal systeem)
                 'vertical'   → schat de HOOGTE (voor een verticaal systeem)
                 anders/leeg  → valt terug op 'horizontal' (breedte)
  */
  function estimateFrameDimension(dimensions, orientation) {
    if (!dimensions || !dimensions.length) return 0;

    var useHeight = (orientation === 'vertical');

    var totalArea = 0;
    var maxSide = 0;
    var sumSide = 0;

    dimensions.forEach(function (d) {
      totalArea += d.h * d.w;
      var side = useHeight ? d.h : d.w;
      if (side > maxSide) maxSide = side;
      sumSide += side;
    });

    var raw = useHeight
      ? FRAME_AREA_SAFETY_FACTOR * Math.sqrt(totalArea / FRAME_AREA_RATIO)
      : FRAME_AREA_SAFETY_FACTOR * Math.sqrt(totalArea * FRAME_AREA_RATIO);

    if (raw < maxSide) raw = maxSide;   // ondergrens: breedste/hoogste lijstje
    if (raw > sumSide) raw = sumSide;   // bovengrens: alles op 1 rij

    // ── Bij precies 1 lijstje vallen onder- en bovengrens samen, dus de clamp
    //    forceert dan altijd exact de eigen maat (geen speling). Tel er
    //    daarom een vaste marge bij op. ──
    if (dimensions.length === 1) raw += SINGLE_FRAME_MARGIN;

    return Math.round(raw);
  }

  /*
    Totale lengte (mm) die een set frame-items inneemt in het systeem.
    Wordt aangeroepen vanuit getAddonLength() in configurator.js.
    overrideDimension: optioneel, per add-on ("data-length-dimension"),
    zie resolveLengthOrientation() hierboven.

    De geschatte breedte wordt bij het bevestigen (getItems) één keer
    berekend en als "estimatedWidth" op het eerste item gezet, zodat we
    hier niet opnieuw uit de opgeslagen tekst-properties hoeven te parsen.
  */
  function getItemsLength(frameItemsRaw, orientation, overrideDimension) {
    var items = frameItemsRaw;
    if (typeof items === 'string') {
      try { items = JSON.parse(items || '[]'); } catch (e) { return 0; }
    }
    if (!items || !items.length) return 0;

    var field = (resolveLengthOrientation(orientation, overrideDimension) === 'vertical') ? 'estimatedHeight' : 'estimatedWidth';

    var total = 0;
    items.forEach(function (item) {
      if (item && item[field]) total += Number(item[field]) || 0;
    });
    return total;
  }

  /*
    Minimaal mogelijke ruimte (mm) die deze add-on ooit zou kunnen innemen:
    precies 1 lijstje op de kleinst toegestane maat (settings.min × settings.min).
    Gebruikt door updateAddonAvailability() in configurator.js om te bepalen of
    deze add-on nog aangevinkt kan worden, vóórdat er ook maar iets is ingevuld
    — de statische tierLengths (allemaal 0) zijn daar niet bruikbaar voor, want
    de werkelijke ruimte hangt af van de maten die iemand nog gaat invullen.
    overrideDimension: optioneel, per add-on, zie resolveLengthOrientation().
  */
  function getMinPossibleLength(orientation, overrideDimension) {
    return estimateFrameDimension([{ h: settings.min, w: settings.min }], resolveLengthOrientation(orientation, overrideDimension));
  }

  function optionName(opt) {
    return (opt && opt.name) ? opt.name : String(opt);
  }

  function injectStyles() {
    if (document.getElementById('pfm-styles')) return;
    var style = document.createElement('style');
    style.id = 'pfm-styles';
    style.textContent = [
      '.pfm{margin-top:18px}',
      '.pfm__label{display:block;font-weight:600;font-size:.875rem;margin-bottom:6px}',
      '.pfm__count{width:100%;padding:10px 12px;border:1px solid #d7d7d7;border-radius:8px;background:#fff;font-size:1rem;margin-bottom:14px}',
      '.pfm__frames{display:flex;flex-direction:column;gap:10px}',
      '.pfm__frame{border:1px solid #e5e5e5;border-radius:10px;padding:10px 12px}',
      '.pfm__frame-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;font-weight:600;font-size:.85rem}',
      '.pfm__badge{font-size:.72rem;font-weight:600;padding:3px 10px;border-radius:999px;background:#f1f1f1;color:#666}',
      '.pfm__badge--tier{background:#e8f7ee;color:#2f9c5c}',
      '.pfm__badge--error{background:#fdecec;color:#cc0000}',
      '.pfm__inputs{display:flex;gap:10px}',
      '.pfm__inputs input{flex:1 1 0;min-width:0;width:100%;box-sizing:border-box;padding:9px 10px;border:1px solid #d7d7d7;border-radius:8px;font-size:.95rem}',
      '.pfm__error{display:none;color:#cc0000;font-size:.85rem;margin:10px 0 0}',
      '.pfm__error.is-visible{display:block}',
      /* ── DEBUG: debug-regel voor de ruimteschatting, alleen zichtbaar als DEBUG_FRAME_ESTIMATE hierboven op true staat ── */
      '.pfm__debug{margin-top:10px;padding:8px 10px;border:1px dashed #f59e0b;border-radius:8px;background:#fffbeb;color:#92400e;font-size:.85rem;font-weight:600}'
    ].join('');
    document.head.appendChild(style);
  }

  // Verbergt de Size-optie in de modal: die wordt afgeleid uit de ingevoerde maten
  function hideSizeGroup(variantPicker) {
    var target = String(settings.sizeOptionName).toLowerCase();
    variantPicker.querySelectorAll('.configurator__option-group').forEach(function (group) {
      var label = group.querySelector('.configurator__option-label');
      if (label && label.textContent.trim().toLowerCase() === target) {
        group.style.display = 'none';
        group.dataset.pfmHidden = 'true';
      }
    });
  }

  /* ── Mount ───────────────────────────────────────────────── */

  /*
    opts = {
      product,        // product object uit /products/<handle>.json
      variantPicker,  // element met de optie-groepen uit de modal
      priceEl,        // (optioneel) element waarin het totaal getoond wordt
      confirmBtn,     // (optioneel) "Add to system" knop
      initialState    // (optioneel) [{h:'80', w:'120'}, ...]
    }
  */
  function mount(opts) {
    injectStyles();

    var product       = opts.product;
    var handle        = product.handle;
    var variantPicker = opts.variantPicker;
    var priceEl       = opts.priceEl || null;
    var confirmBtn    = opts.confirmBtn || null;
    var orientation   = opts.orientation || null; // 'horizontal' | 'vertical' | null
    // Per add-on override ("data-length-dimension" op de "View"-knop), zie
    // resolveLengthOrientation() hierboven.
    var lengthDimension = opts.lengthDimension || null;
    var maxFrames     = Math.min(parseInt(settings.maxFrames, 10) || 10, totalLimit());

    // ── Hoeveel ruimte (mm) er nog beschikbaar is in het systeem, exclusief
    //    wat deze add-on zelf al innam vóór deze modal geopend werd — door
    //    configurator.js meegegeven. Zonder deze functie (bv. oudere
    //    aanroep) wordt nooit "te groot" gemeld, exact het oude gedrag. ──
    var getAvailableLength = (typeof opts.getAvailableLength === 'function')
      ? opts.getAvailableLength
      : function () { return Infinity; };

    hideSizeGroup(variantPicker);

    var wrap = document.createElement('div');
    wrap.className = 'pfm';

    var label = document.createElement('label');
    label.className = 'pfm__label';
    label.textContent = 'Select number of photo frames';

    var countSelect = document.createElement('select');
    countSelect.className = 'pfm__count';
    for (var i = 1; i <= maxFrames; i++) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = String(i);
      countSelect.appendChild(opt);
    }

    var framesContainer = document.createElement('div');
    framesContainer.className = 'pfm__frames';

    // ── DEBUG: laat live zien met hoeveel ruimte de berekening rekening
    //    houdt. Wordt alleen aangemaakt (en dus getoond) als
    //    DEBUG_FRAME_ESTIMATE hierboven op true staat. ──
    var debugEl = null;
    if (DEBUG_FRAME_ESTIMATE) {
      debugEl = document.createElement('p');
      debugEl.className = 'pfm__debug';
      debugEl.textContent = 'TEST — geschatte ' + (resolveLengthOrientation(orientation, lengthDimension) === 'vertical' ? 'hoogte' : 'breedte') + ' in systeem: 0 mm';
    }

    var errorEl = document.createElement('p');
    errorEl.className = 'pfm__error';
    errorEl.textContent = 'Please fill in all boxes';

    wrap.appendChild(label);
    wrap.appendChild(countSelect);
    wrap.appendChild(framesContainer);
    if (debugEl) wrap.appendChild(debugEl);
    wrap.appendChild(errorEl);

    function showError(message) {
      errorEl.textContent = message || 'Please fill in all boxes';
      errorEl.classList.add('is-visible');
    }
    function hideError() {
      errorEl.classList.remove('is-visible');
    }

    function buildFrames(count) {
      var existing = {};
      framesContainer.querySelectorAll('.pfm__frame').forEach(function (el) {
        existing[el.dataset.index] = {
          h: el.querySelector('.pfm-h').value,
          w: el.querySelector('.pfm-w').value
        };
      });
      framesContainer.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var prev  = existing[i] || { h: '', w: '' };
        var frame = document.createElement('div');
        frame.className     = 'pfm__frame';
        frame.dataset.index = i;
        frame.innerHTML =
          '<div class="pfm__frame-head">' +
            '<span>Frame ' + (i + 1) + '</span>' +
            '<span class="pfm__badge">&mdash;</span>' +
          '</div>' +
          '<div class="pfm__inputs">' +
            '<input type="number" min="0" step="1" class="pfm-h" placeholder="Height (mm)" value="' + prev.h + '">' +
            '<input type="number" min="0" step="1" class="pfm-w" placeholder="Width (mm)" value="' + prev.w + '">' +
          '</div>';
        framesContainer.appendChild(frame);
      }
      refresh();
    }

    // Werkt badges, totaalprijs, de ruimte-schatting en de confirm-knop bij. Geeft true terug als alles geldig is.
    function refresh() {
      var total = 0;
      var valid = true;
      var overLimit = false;
      var counts = { Small: 0, Medium: 0, Large: 0 };
      var dimensions = []; // ── RUIMTE-SCHATTING: alleen geldige maten ──

      framesContainer.querySelectorAll('.pfm__frame').forEach(function (el) {
        var h = parseFloat(el.querySelector('.pfm-h').value);
        var w = parseFloat(el.querySelector('.pfm-w').value);
        var badge = el.querySelector('.pfm__badge');
        badge.className = 'pfm__badge';

        var hCheck = validateSingle(h);
        var wCheck = validateSingle(w);
        var bad = !hCheck.valid ? hCheck : (!wCheck.valid ? wCheck : null);

        if (bad) {
          valid = false;
          badge.innerHTML = bad.error === 'empty' ? '&mdash;' : bad.error;
          if (bad.error !== 'empty') badge.classList.add('pfm__badge--error');
          return;
        }

        dimensions.push({ h: h, w: w }); // ── RUIMTE-SCHATTING ──

        var result = classifyTier(h, w);
        counts[result.tier]++;

        // Te veel frames van deze tier: dit frame markeren als fout
        var limit = tierLimit(result.tier);
        if (limit !== null && counts[result.tier] > limit) {
          valid = false;
          overLimit = true;
          badge.textContent = 'Max ' + limit + ' ' + result.tier;
          badge.classList.add('pfm__badge--error');
          return;
        }

        badge.textContent = result.tier;
        badge.classList.add('pfm__badge--tier');
        total += result.price;
      });

      if (!framesContainer.querySelectorAll('.pfm__frame').length) valid = false;

      if (priceEl) priceEl.textContent = formatMoney(total);

      // ── Past de geschatte ruimte nog in wat er in het systeem over is?
      //    Alleen checken als de invoer zelf al geldig is — eerst de losse
      //    maten/tier-limieten laten kloppen, dan pas de systeemruimte. ──
      var lengthOrientation = resolveLengthOrientation(orientation, lengthDimension);
      var estimatedSpace = estimateFrameDimension(dimensions, lengthOrientation);
      var availableLength = getAvailableLength();
      var tooLargeForSystem = valid && dimensions.length > 0 &&
        isFinite(availableLength) && estimatedSpace > availableLength;
      if (tooLargeForSystem) valid = false;

      // ── DEBUG: geschatte breedte/hoogte (en beschikbare ruimte) live
      //    tonen tijdens het invullen — alleen als debugEl bestaat ──
      if (debugEl) {
        debugEl.textContent = 'TEST — geschatte ' + (lengthOrientation === 'vertical' ? 'hoogte' : 'breedte') +
          ' in systeem: ' + estimatedSpace + ' mm' +
          (isFinite(availableLength) ? ' (beschikbaar: ' + availableLength + ' mm)' : '');
      }

      if (confirmBtn) {
        if (tooLargeForSystem) {
          // ── Zelfde melding/stijl als bij een te groot regulier product
          //    (zie updateConfirmBtn() in configurator.js) ──
          confirmBtn.textContent = 'Product too large!';
          confirmBtn.disabled = true;
          confirmBtn.style.background = '#9ca3af';
          confirmBtn.style.color = '#ffffff';
          confirmBtn.style.cursor = 'not-allowed';
        } else {
          confirmBtn.textContent = 'Add to system';
          confirmBtn.disabled = !valid;
          confirmBtn.style.background = valid ? '' : '#9ca3af';
          confirmBtn.style.color      = valid ? '' : '#ffffff';
          confirmBtn.style.cursor     = valid ? '' : 'not-allowed';
        }
      }

      if (valid) hideError();
      else if (overLimit) showError(limitsText());
      return valid;
    }

    function getState() {
      return Array.prototype.map.call(framesContainer.querySelectorAll('.pfm__frame'), function (el) {
        return { h: el.querySelector('.pfm-h').value, w: el.querySelector('.pfm-w').value };
      });
    }

    function applyState(st) {
      var n = (st && st.length) ? Math.min(st.length, maxFrames) : 1;
      countSelect.value = String(n);
      buildFrames(n);
      if (!st || !st.length) return;
      framesContainer.querySelectorAll('.pfm__frame').forEach(function (el, i) {
        if (!st[i]) return;
        el.querySelector('.pfm-h').value = st[i].h || '';
        el.querySelector('.pfm-w').value = st[i].w || '';
      });
      refresh();
    }

    // Zoekt de variant-id voor een tier, met de overige (zichtbare) opties zoals gekozen
    function findVariantId(tier) {
      var selected = product.options.map(function (opt) {
        var name = optionName(opt);
        if (name.toLowerCase() === String(settings.sizeOptionName).toLowerCase()) return tier;
        var checked = variantPicker.querySelector('input[name="modal-' + handle + '-' + name + '"]:checked');
        if (checked) return checked.value;
        return (opt.values && opt.values[0]) ? opt.values[0] : '';
      });
      var title = selected.join(' / ');
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].title === title) return product.variants[i].id;
      }
      return null;
    }

    /*
      Bouwt de cart line items: één regel per tier, met quantity = aantal frames
      in die tier en de exacte maten als line item property. De geschatte totale
      breedte (RUIMTE-SCHATTING) wordt één keer berekend en op het eerste item
      gezet, zodat getItemsLength() die zo weer kan optellen.
      Geeft { items: [...], missing: ['Large'] } terug.
    */
    function getItems() {
      var tiers = { Small: [], Medium: [], Large: [] };
      var dimensions = []; // ── RUIMTE-SCHATTING ──

      framesContainer.querySelectorAll('.pfm__frame').forEach(function (el, i) {
        var h = parseFloat(el.querySelector('.pfm-h').value);
        var w = parseFloat(el.querySelector('.pfm-w').value);
        if (!validateSingle(h).valid || !validateSingle(w).valid) return;
        var result = classifyTier(h, w);
        tiers[result.tier].push('Frame ' + (i + 1) + ': ' + h + 'x' + w + ' mm');
        dimensions.push({ h: h, w: w }); // ── RUIMTE-SCHATTING ──
      });

      // ── RUIMTE-SCHATTING: beide richtingen berekenen, ongeacht welke oriëntatie
      //    nu actief is — zo klopt de opgeslagen data ook als iemand later
      //    tussen horizontal/vertical wisselt ──
      var estimatedWidth  = estimateFrameDimension(dimensions, 'horizontal');
      var estimatedHeight = estimateFrameDimension(dimensions, 'vertical');

      var items = [];
      var missing = [];
      var isFirstItem = true;

      ['Small', 'Medium', 'Large'].forEach(function (tier) {
        if (tiers[tier].length === 0) return;
        var variantId = findVariantId(tier);
        if (!variantId) { missing.push(tier); return; }

        var itemObj = {
          id: variantId,
          tier: tier,
          quantity: tiers[tier].length,
          properties: {
            'Frames': tiers[tier].join(' | '),
            'Total frames': String(tiers[tier].length)
          }
        };

        // ── RUIMTE-SCHATTING: alleen op het eerste item, zodat getItemsLength()
        //    'm niet per ongeluk meerdere keren optelt ──
        if (isFirstItem) {
          itemObj.estimatedWidth  = estimatedWidth;
          itemObj.estimatedHeight = estimatedHeight;
          isFirstItem = false;
        }

        items.push(itemObj);
      });

      return { items: items, missing: missing };
    }

    function getSummary() {
      var counts = { Small: 0, Medium: 0, Large: 0 };
      var total = 0;
      framesContainer.querySelectorAll('.pfm__frame').forEach(function (el) {
        var h = parseFloat(el.querySelector('.pfm-h').value);
        var w = parseFloat(el.querySelector('.pfm-w').value);
        if (!validateSingle(h).valid || !validateSingle(w).valid) return;
        counts[classifyTier(h, w).tier]++;
        total++;
      });
      var parts = [];
      ['Small', 'Medium', 'Large'].forEach(function (t) {
        if (counts[t]) parts.push(counts[t] + '\u00d7 ' + t);
      });
      return total + (total === 1 ? ' frame' : ' frames') + (parts.length ? ' (' + parts.join(', ') + ')' : '');
    }

    countSelect.addEventListener('change', function () {
      hideError();
      buildFrames(parseInt(countSelect.value, 10));
    });

    framesContainer.addEventListener('input', function (e) {
      if (e.target.classList.contains('pfm-h') || e.target.classList.contains('pfm-w')) {
        hideError();
        refresh();
      }
    });

    applyState(opts.initialState);

    return {
      el: wrap,
      refresh: refresh,
      isValid: refresh,
      showError: showError,
      hideError: hideError,
      getItems: getItems,
      getState: getState,
      getSummary: getSummary
    };
  }

  return {
    settings: settings,
    isFrameProduct: isFrameProduct,
    classifyTier: classifyTier,
    validateSingle: validateSingle,
    getItemsLength: getItemsLength,
    getMinPossibleLength: getMinPossibleLength,
    mount: mount
  };
})();